// extracted by mini-css-extract-plugin
export default {"excludeBadge":"ExcludeByDateBadge_excludeBadge__XMsia","excludeBadgeIcon":"ExcludeByDateBadge_excludeBadgeIcon__3sYmf"};